import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AnexoTO } from "src/app/data/schema/Courses/AnexoTO";

@Component({
    selector: "app-attachment-video",
    templateUrl: "./attachment-video.component.html",
    styleUrls: ["./attachment-video.component.scss"]
})
export class AttachmentVideoComponent implements OnInit, AfterContentInit {
    @Input("attachment")
    public attachment!: AnexoTO;

    @Output("video-complete")
    private emitVideoComplete = new EventEmitter<boolean>();

    public playerId: string;
    public playerName: string;

    constructor() {}

    ngOnInit() {}

    ngAfterContentInit() {}

    public VideoConvertComplete() {
        this.emitVideoComplete.emit(true);
    }
}
